<template>
  <v-card class="mt-2">
    <v-tabs v-model="tab">
      <v-tab>バイヤーコード設定</v-tab>
      <v-tab-item>
        <v-card>
          <v-card-title>バイヤーコード設定</v-card-title>
          <v-card-actions>
            <v-btn @click="addBuyerCode()">行追加</v-btn>
            <v-btn
              :disabled="codeSelected.length !== 1"
              @click="editBuyerCode()"
              >編集</v-btn
            >
            <v-btn
              :disabled="codeSelected.length === 0"
              @click="removeBuyerCode()"
              >削除</v-btn
            >
          </v-card-actions>
          <v-data-table
            :headers="codeHeaders"
            :items="buyerCodes"
            :rows-per-page-items="[-1]"
            class="inline-edit"
            item-key="code"
            select-all
            v-model="codeSelected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
      <v-tab v-if="$route.query.id">送信宛先設定</v-tab>
      <v-tab-item>
        <v-card>
          <v-card-title>送信宛先設定</v-card-title>
          <v-card-actions>
            <v-btn @click="addBuyerReceiver()">行追加</v-btn>
            <v-btn
              :disabled="receiverSelected.length !== 1"
              @click="editBuyerReceiver()"
              >編集</v-btn
            >
            <v-btn
              :disabled="receiverSelected.length === 0"
              @click="removeBuyerReceiver()"
              >削除</v-btn
            >
          </v-card-actions>
          <v-data-table
            key="2"
            :headers="receiversHeaders"
            :items="buyerReceivers"
            :rows-per-page-items="[-1]"
            class="inline-edit"
            item-key="id"
            select-all
            v-model="receiverSelected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.buyerCode }}</td>
              <td>{{ props.item.receiverName }}</td>
              <td>{{ props.item.receiverMail }}</td>
              <td>{{ props.item.transportModes }}</td>
              <td>{{ props.item.receiverCompanyName }}</td>
              <td>{{ props.item.remark }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <add-buyer-code-dialog
      :company="company"
      :buyerCodes="buyerCodes"
      @refresh="load()"
      @addTempBuyer="addTempBuyer"
      ref="buyerCode"
    ></add-buyer-code-dialog>
    <add-buyer-user-dialog
      :company="company"
      @refresh="load()"
      ref="buyerUser"
    ></add-buyer-user-dialog>
  </v-card>
</template>

<script>
import AddBuyerCodeDialog from "./AddBuyerCodeDialog.vue";
import AddBuyerUserDialog from "./AddBuyerUserDialog.vue";

export default {
  components: {
    AddBuyerCodeDialog,
    AddBuyerUserDialog,
  },
  props: ["company"],
  data() {
    return {
      tabs: null,
      receiverSelected: [],
      codeSelected: [],
      codeHeaders: [
        {
          text: "バイヤーコード",
          sortable: false,
        },
        {
          text: "部署名称",
          sortable: false,
        },
      ],
      buyerCodes: [],
      buyerReceivers: [],
      receiversHeaders: [
        {
          text: "バイヤーコード",
          sortable: false,
        },
        {
          text: "宛先名",
          sortable: false,
        },
        {
          text: "メールアドレス",
          sortable: false,
        },
        {
          text: "输送区分",
          sortable: false,
        },
        {
          text: "会社名",
          sortable: false,
        },
        {
          text: "備考",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    load() {
      if (this.company) {
        this.$http
          .get(`buyers/company/${this.company.companyId}/code`)
          .then((res) => {
            this.buyerCodes = res.data;
            this.codeSelected = [];
          });
        this.$http
          .get(`buyers/company/${this.company.companyId}/receiver`)
          .then((res) => {
            this.buyerReceivers = res.data;
            this.receiverSelected = [];
          });
      }
    },
    addBuyerCode() {
      this.$refs.buyerCode.popup("NEW", {});
    },
    addTempBuyer(tempBuyer) {
      this.buyerCodes.push(tempBuyer);
    },
    editBuyerCode() {
      this.$refs.buyerCode.popup("EDIT", this.codeSelected[0]);
    },
    removeBuyerCode() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        if (!this.company.companyId) {
          this.codeSelected.forEach((cs) => {
            var index = this.buyerCodes.indexOf(cs);
            if (index > -1) {
              this.buyerCodes.splice(index, 1);
            }
          });
          this.codeSelected = [];
          return;
        }
        Promise.all(
          this.codeSelected.map((s) => {
            return this.$http.delete(`/buyers/code/${s.code}`);
          })
        )
          .then(() => {
            this.load();
            this.$message("", "buyerCode削除しました。");
          })
          .catch((err) => {
            this.$message("", "buyerCode削除失敗しました。");
          });
      });
    },
    addBuyerReceiver() {
      this.$refs.buyerUser.popup("NEW", {});
    },
    editBuyerReceiver() {
      this.$refs.buyerUser.popup("EDIT", this.receiverSelected[0]);
    },
    removeBuyerReceiver() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        Promise.all(
          this.receiverSelected.map((r) => {
            return this.$http.delete(`/buyers/receiver/${r.id}`);
          })
        )
          .then(() => {
            this.load();
            this.$message("", "送信宛先削除しました。");
          })
          .catch((err) => {
            this.$message("", "送信宛先削除失敗しました。");
          });
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
